var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.85,
    d: "m11.156 9.999 5.86-6.984a.177.177 0 0 0-.137-.293H15.1a.36.36 0 0 0-.275.127L9.99 8.611 5.158 2.849a.36.36 0 0 0-.274-.127H3.103a.178.178 0 0 0-.137.293l5.86 6.984-5.86 6.984a.177.177 0 0 0 .137.293h1.78a.36.36 0 0 0 .275-.128l4.833-5.76 4.833 5.76c.066.08.167.128.274.128h1.781a.177.177 0 0 0 .136-.293z"
  })));
};
export default SvgClose;